"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/AddServices.css');

var RecentLocations = /*#__PURE__*/function (_React$Component) {
  _inherits(RecentLocations, _React$Component);

  var _super = _createSuper(RecentLocations);

  function RecentLocations() {
    _classCallCheck(this, RecentLocations);

    return _super.apply(this, arguments);
  }

  _createClass(RecentLocations, [{
    key: "render",
    value: function render() {
      var _userData$recentLocat;

      var _this$props = this.props,
          userData = _this$props.userData,
          recentLocationsLimit = _this$props.recentLocationsLimit,
          handleUseLocation = _this$props.handleUseLocation;
      var dashCharRegex = / [-–—]/g; // two different dash characters

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "recent-locations"
      }, !!(userData !== null && userData !== void 0 && (_userData$recentLocat = userData.recentLocations) !== null && _userData$recentLocat !== void 0 && _userData$recentLocat.length) ? userData.recentLocations.slice(0, recentLocationsLimit).map(function (location) {
        var newLocation = {
          address: {
            city: location.city,
            name: location.name,
            street: location.address,
            address: location.address,
            state: location.state,
            zip: location.zip
          },
          coords: location.coords,
          display: location.name,
          text: location.name,
          uniqueKey: location.name,
          value: 'place',
          profileImage: location.profileImage
        };
        var avatarImage = !location.profileImage ? null : /*#__PURE__*/_react.default.createElement("div", {
          className: "location-avatar",
          style: {
            backgroundImage: "url(".concat(location.profileImage, ")")
          }
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          key: location._id,
          className: "recent-locations-item"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "recent-loc-left"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "recent-locations-item-title"
        }, location.name.split(dashCharRegex)[0]), /*#__PURE__*/_react.default.createElement("p", {
          className: "sub-title"
        }, "".concat(location.address, ", ").concat(location.city))), /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick(e) {
            e.preventDefault();
            handleUseLocation(newLocation)();
          }
        }, "Use Location"));
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          minHeight: '35rem'
        }
      }, "No Recent Locations"));
    }
  }]);

  return RecentLocations;
}(_react.default.Component);

exports.default = RecentLocations;
RecentLocations.propTypes = {
  userData: _propTypes.default.object.isRequired,
  recentLocationsLimit: _propTypes.default.number.isRequired,
  handleUseLocation: _propTypes.default.func.isRequired
};